// Generated by scripts/update-seeq-icons.js from src/svg/seeq/folder-lock.svg.
// Do not edit this file directly; update the source SVG and regenerate.
import type { IconDefinition, IconName } from '@fortawesome/fontawesome-common-types';

export const fcFolderLock = {
  prefix: 'fak',
  iconName: 'folder-lock' as IconName,
  icon: [
    1511,
    1024,
    [],
    'f962',
    'M1488 351.5c-20.9-27.9-53.2-44.5-88.9-44.5h-47.1v-196.2c0-61.1-49.7-110.8-110.8-110.8h-273.9c-29.7 0-57.6 11.3-78.5 32.3l-67.2 67.1h-420.4c-19.2 0-36.6 6.1-52.3 14.9 82 10.5 157 46.2 212.8 102h262.6c29.7 0 57.6-11.3 78.5-32.3l67.1-67.1h264.3v190.1h-607.9c19.2 35.8 32.3 75.9 37.5 117.8h725.7l-139.6 402.1h-527.7v117.7h532.9c48 0 91.6-32.3 105.6-77.6l143.9-414.3v-2.6c10.5-34 4.4-69.8-16.6-97.7v0zM522.5 1024c48 0 86.4-38.4 86.3-86.4v-299.1c0-35.8-21.8-66.3-52.3-79.4v-83.7c0-138.7-113.4-252.1-252.1-252.1s-252.1 113.4-252.1 252.1v83.7c-30.5 13.1-52.3 43.6-52.3 79.4v299.1c0 48 38.4 86.4 86.4 86.4h436.1zM168.3 475.4c0-75 61.1-136.1 136.1-136.1s136.1 61.1 136.1 136.1v76.7h-272.2v-76.7z',
  ],
} satisfies IconDefinition;
